import React from "react";
import PropTypes from "prop-types";
import cx from "clsx";
import { AlertBox } from "../../../../../shared/AlertBox/AlertBox";
import { TriangleAlertIcon } from "../../../../../assets/Icons/TriangleAlertIcon";
import styles from "../scss/VisaComplianceAcknowledgement.module.scss";

const CHECKBOX_ID = "visa_compliance_fee_acknowledged";
const ERROR_ID = "visa_compliance_fee_acknowledged_error";

/**
 * Visa compliance disputes cost 500 USD in network fees to contest, and Stripe
 * refuses the evidence submission until that fee is explicitly acknowledged.
 * https://docs.stripe.com/disputes/api/visa-compliance
 */
const VisaComplianceAcknowledgement = ({ checked, onChange, hasError }) => {
  return (
    <AlertBox variant="warn" className={styles.root}>
      <div className={styles.header}>
        <TriangleAlertIcon width="18px" className={styles.icon} />
        <h5 className={styles.title}>Visa compliance dispute</h5>
      </div>
      <p className={styles.text}>
        Contesting this dispute costs an additional <strong>500 USD</strong> (or
        local equivalent) network fee on top of the usual dispute fees. Stripe
        withdraws it from your balance within 1-2 days of submitting evidence
        and refunds it if you win the dispute.
      </p>
      <p className={styles.text}>
        Accepting the dispute instead of submitting evidence does not incur this
        network fee.
      </p>
      <label
        className={cx(styles.confirm, { [styles.confirmError]: hasError })}
        htmlFor={CHECKBOX_ID}
      >
        <input
          type="checkbox"
          id={CHECKBOX_ID}
          name={CHECKBOX_ID}
          className={styles.checkbox}
          checked={checked}
          onChange={(event) => onChange(event.target.checked)}
          aria-invalid={hasError}
          aria-describedby={hasError ? ERROR_ID : undefined}
        />
        <span className={styles.confirmLabel}>
          I acknowledge the 500 USD Visa compliance network fee.
        </span>
      </label>
      {hasError && (
        <span className={styles.error} id={ERROR_ID} role="alert">
          Acknowledge the network fee before submitting your evidence.
        </span>
      )}
    </AlertBox>
  );
};

VisaComplianceAcknowledgement.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
};

VisaComplianceAcknowledgement.defaultProps = {
  hasError: false,
};

export default VisaComplianceAcknowledgement;
